export default {
    data() {
        return {
            visibleText: false,
            openText: false,
        }
    },
    mounted() {
        // setTimeout(() => {
        //     this.visibleText = this.$refs.desc.clientHeight >= 340;
        // }, 500);
    },
    methods: {

    }
};



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/double-block/component.js